import React from 'react'
import MarginOptions from './MarginOptions'
import SVGInput from './SVGInput'
import RightBarGroup from './RightBarGroup'
import Input from './Input'
import {
  Bullet,
  BulletsData,
  ChangeEvent,
  DynamicContentType,
  jsonCopy,
  LucideIconName,
} from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

export type RightBarEditorProps<T> = {
  content: DynamicContentType<T>
  setData: (event: ChangeEvent<Bullet[] | string>) => void
}

const BulletPointsEditor = ({
  setData,
  content,
}: RightBarEditorProps<BulletsData>) => {
  const { tr } = useTr()

  const onChange = (
    e: ChangeEvent<string | LucideIconName>,
    i: number,
    key: 'text' | 'icon'
  ) => {
    const updated = jsonCopy(content.data)
    const { value } = e.target
    if (key === 'icon') {
      updated.bullets[i].icon = value as LucideIconName
    } else {
      updated.bullets[i].text = value as string
    }

    const updateEvent = {
      target: {
        name: 'bullets',
        value: updated.bullets,
      },
    }
    setData(updateEvent)
  }

  return (
    <>
      {content.data.bullets.map((_card, i) => (
        <React.Fragment key={`bullet_edit_${content.uuid}_${i}`}>
          <RightBarGroup title={`${tr(TrKey.bulletPointsEditorRow)} #${i + 1}`}>
            <Input
              light
              label={tr(TrKey.bulletPointsEditorText)}
              id={`bulletText_${i}`}
              value={content.data.bullets[i].text}
              onChange={(e) => onChange(e, i, 'text')}
            />
            <SVGInput
              value={content.data.bullets[i].icon}
              onChange={(e) => onChange(e, i, 'icon')}
            />
          </RightBarGroup>
        </React.Fragment>
      ))}
      <MarginOptions content={content} setData={setData} />
    </>
  )
}

export default BulletPointsEditor
